import {atom} from 'jotai';


export const CounterOfferPrices = atom<Array<{ bundleOrderedPartConfigId: number, counterOfferPrice: number, batchSize: number, active: boolean }>>([]);
export const CounterOfferModal_CounterOfferDate = atom<Date | null>(null);
export const ZoomModal_CurrentBundleOrderedPartConfigId = atom<number | null>(null);
export const ZoomModal_Open = atom<boolean>(false);
export const ZoomModal_MousePosition = atom<{ x: number, y: number }>({x: 0, y: 0});